var FormDetailsModule = /** @class */ (function () {
    function FormDetailsModule() {
    }
    return FormDetailsModule;
}());
export { FormDetailsModule };
